import React from 'react';
export function Footer() {
  return <footer className="bg-earth-900 border-t border-white/5 py-12 relative" data-id="element-46">
      <div className="absolute inset-0 bg-grain opacity-20 pointer-events-none mix-blend-overlay" data-id="element-47"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 text-center" data-id="element-48">
        <p className="text-cream-50/40 text-sm" data-id="element-49">
          Copyright © 2025 Mark Vermeulen Coaching | Privacybeleid
        </p>
      </div>
    </footer>;
}